// sudoku-ml — the privacy policy, as markup.
//
// MOVED HERE ON 19 SEP 2026 out of `public/privacy.html`, which was deleted — the
// nodejavascript.com site standard (parts 1b and 4) requires the policy to be a section
// of the page rather than a page of its own.
//
// 🔴 THEN MINIMISED AND CORRECTED ON 22 SEP 2026 (George: "mast update the privacy collect,
// cookies, remove contact remove changes. minimize and reevalaute all copy"). What changed and
// why: the page no longer claims a "built-in solver", because the solution button was commented
// out the same day; it no longer claims the site holds "nothing", because the mistake tally is
// now stored with each game and a policy has to name what it keeps; "anonymous page views" lost
// the word anonymous, because Google Analytics sets an identifier and the honest version is the
// one that survives being read; and the Contact and Changes sections are gone — the footer's
// brand line already leads to nodejavascript.com, and a policy that promises to update itself
// is a promise nobody checks.
const policyHtml = `<h2>Privacy policy</h2>
      <p class="stamp">Last changed 22 September 2026.</p>

      <p>
        This covers one site: <b>sudoku-ml.nodejavascript.com</b>. It describes what the code
        does, because a policy the site does not keep to is worse than none.
      </p>

      <h2>What the site collects</h2>
      <p>
        <b>Nothing is sent to a server.</b> Puzzles are made and checked in your own browser.
        There is no account and no sign-in.
      </p>
      <p>
        Your games — the board, the difficulty, how far you have got and how many mistakes you
        have made — are kept in this browser's own storage so a refresh does not lose them.
        Clearing your browser data removes them.
      </p>

      <h2>Cookies</h2>
      <p>
        One optional cookie, and it is off unless you turn it on: <b>Google Analytics</b>,
        which records page views, which controls are pressed and how far down a page people
        read. It never receives your puzzle or anything you have solved.
      </p>
      <p>
        <b>Google's script is not in this page at all.</b> It is added only if you allow it, so
        a visit that refuses makes no request to Google and receives no cookie.
      </p>
      <p>
        Change your answer at any time with <b>Cookie settings</b> in the footer.
      </p>`

export default policyHtml
